/* global $fetch */
const state = reactive({
  answer: '',
  sources: [],
  loading: false,
  error: null,
})

export function useAiSearch() {
  async function askAi(query, locale) {
    if (!query?.trim())
      return

    state.loading = true
    state.error = null

    try {
      const data = await $fetch('/api/search/ai', {
        method: 'POST',
        body: { query, locale },
      })
      state.answer = data.answer
      state.sources = data.sources
    }
    catch (error) {
      console.log(error)
      state.error = error
      state.answer = ''
      state.sources = []
    }
    finally {
      state.loading = false
    }
  }

  function resetAiSearch() {
    state.answer = ''
    state.sources = []
    state.error = null
  }

  return {
    ...toRefs(state),
    askAi,
    resetAiSearch,
  }
}
